<template>
  <div>


    <el-table border stripe :data="list" style="width: 100%">
      <el-table-column prop="company" label="公司名称"></el-table-column>
      <el-table-column prop="licenseUrl" label="营业执照">
        <template v-slot:default="scope">
          <cloud-img :img-width="60" :img-height="60" :click-view="true" :url="scope.row.licenseUrl"></cloud-img>
        </template>
      </el-table-column>
      <el-table-column prop="workProofUrl" label="工作证明">
        <template v-slot:default="scope">
          <cloud-img :img-width="60" :img-height="60" :click-view="true" :url="scope.row.workProofUrl"></cloud-img>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140px">
        <template v-slot:default="scope">
          <el-button size="mini" @click="examine(scope.row.id,true)" type="text">审批通过</el-button>
          <el-button size="mini" @click="examine(scope.row.id,false)" type="text">审批驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import {user} from "@/api/user";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import CusCertification from "@/components/user/CusCertification.vue";

export default {
  name: 'CustomerExamine',
  components: {CusCertification, CloudImg},

  data() {
    return {
      list: [],

    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      user.listPendingCustomerExamine().then(res => {
        this.list = res.data;
      })
    },

    examine(id, examineFlag) {
      if (!examineFlag) {
        this.$prompt('请输入驳回理由', '提示', {
          confirmButtonText: '立即驳回',
          cancelButtonText: '取消',
        }).then(({value}) => {
          this.sendRequest(id, examineFlag, value);
        });
      } else {
        this.sendRequest(id, examineFlag, null);
      }
    },

    sendRequest(id, examineFlag, rejectedMsg) {
      user.examineCustomer(id, examineFlag, rejectedMsg).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.getData();
          this.$emit("updated");
        }
      })
    },

  },


};
</script>

<style scoped>
</style>
